export default __webpack_public_path__ + "static/media/logo4.2de69eac.png";